function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNight = function SvgNight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.693 15.362c.055-.126-.07-.253-.2-.206v0c-3.567 1.288-7.67.528-10.362-2.163-2.68-2.68-3.442-6.756-2.176-10.312v0c.052-.147-.093-.29-.235-.225l-.029.012c-1.969.89-3.72 2.39-4.75 4.279a9.905 9.905 0 0 0 2.393 12.376 9.914 9.914 0 0 0 6.303 2.27 9.914 9.914 0 0 0 5.55-1.7c1.514-1.022 2.712-2.57 3.468-4.247l.038-.084z",
    stroke: "#323232",
    strokeWidth: 2.122,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd"
    }
  }));
};
export default SvgNight;